<template>
  <div class="container-fluid pt-3">
    <p>C'è stato un errore imprevisto:</p>

    <div v-if="getErrorMessage === false">
      Errore sconosciuto.
    </div>

    <div v-if="getErrorMessage !== false">
      {{ getErrorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: "generic",
  props: ['errorMessage'],
  computed: {
    getErrorMessage() {
      // Simplified computed property, no side effects
      const errorMessage = this.errorMessage || this.$route.query.errorMessage;

      if (errorMessage === null || errorMessage === undefined || errorMessage === "" || errorMessage === false) {
        return false;
      }

      return errorMessage;
    }
  },
  beforeMount() {
    if(this.getErrorMessage === "Request failed with status code 403"){
      this.$router.push('/auth/'+sessionStorage.getItem("token"));
    }
  },
  mounted() {
    // Perform redirection after mount if there is a valid error message
    if (this.getErrorMessage) {
      this.redirectAfterNSeconds(5);
    }
  },
  methods: {
    redirectAfterNSeconds(seconds) {
      // Redirect to homepage
      setTimeout(() => {
        this.$router.push('/');
      }, seconds * 1000);
    }
  }
}
</script>
